import type {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

/**
 * The kinds of feedback a Model Hub user can send from the "Get in touch" modal.
 * Keep in sync with benchling/model_hub/constants.py ModelHubFeedbackType
 */
export type ContactUsFeedbackType = 'get_more_credits' | 'report_issue' | 'something_else';

/** Mirrors MAX_FEEDBACK_NOTE_LENGTH in benchling/model_hub/feedback.py. */
export const CONTACT_US_MAX_NOTE_LENGTH = 2500;

export interface ContactUsTabConfig {
  value: ContactUsFeedbackType;
  segmentLabel: string;
  icon: BenchlingIconName;
  noteLabel: string;
  notePlaceholder: string;
  /** Seeded into the note when the user hasn't typed anything yet. Empty means start blank. */
  prefilledNote: string;
}

/** Array order is the left-to-right order of the segmented control. */
export const CONTACT_US_TABS: ReadonlyArray<ContactUsTabConfig> = [
  {
    value: 'report_issue',
    segmentLabel: 'Report issue',
    icon: 'triangle-exclamation-outline',
    noteLabel: 'Please describe the issue',
    notePlaceholder: 'Start typing...',
    prefilledNote: '',
  },
  {
    value: 'get_more_credits',
    segmentLabel: 'Get more credits',
    icon: 'lightbulb-outline',
    noteLabel: 'Add a note',
    notePlaceholder: 'Start typing...',
    prefilledNote:
      'Hi! I’ve almost used up my predictions for this month. Could I get a higher monthly limit?',
  },
  {
    value: 'something_else',
    segmentLabel: 'Something else',
    icon: 'comment-outline',
    noteLabel: 'Please describe the issue',
    notePlaceholder: 'Start typing...',
    prefilledNote: '',
  },
];

/** The modal opens on the leftmost tab, so the initial selection matches the visual order. */
export const DEFAULT_CONTACT_US_TAB = CONTACT_US_TABS[0];

export function getContactUsTab(value: ContactUsFeedbackType): ContactUsTabConfig {
  return CONTACT_US_TABS.find((tab) => tab.value === value) ?? DEFAULT_CONTACT_US_TAB;
}
